enum LoginTypes {
  Email = 'EMAIL',
  Google = 'GOOGLE',
  LinkdIn = 'LINKEDIN',
  Facebook = 'FACEBOOK',
  Outlook = 'OUTLOOK',
}

export default LoginTypes;
